import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 14.75A6.75 6.75 0 1 1 14.75 8 6.76 6.76 0 0 1 8 14.75Zm0-12A5.25 5.25 0 1 0 13.25 8 5.26 5.26 0 0 0 8 2.75ZM11.52 8a.75.75 0 0 0-.75-.75H5.23a.75.75 0 0 0 0 1.5h5.54a.76.76 0 0 0 .75-.75Z';
const draw24px =
  'M17,12.75H7a.75.75,0,0,1,0-1.5H17a.75.75,0,0,1,0,1.5ZM21.75,12A9.75,9.75,0,1,0,12,21.75,9.76,9.76,0,0,0,21.75,12Zm-1.5,0A8.25,8.25,0,1,1,12,3.75,8.26,8.26,0,0,1,20.25,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const MinusCircleIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'minusCircle'),
) as IconWithRender;

MinusCircleIcon.displayName = 'MinusCircleIcon';
MinusCircleIcon.propTypes = Icon.propTypes;
MinusCircleIcon.renderIcon = (props) => <MinusCircleIcon {...props} />;
export default MinusCircleIcon;
